import type { FC } from "react";

import { cn } from "../../utils";
import { Icon, type MaterialSymbol } from "../icon";
import { Spinner } from "../loading";
import { useAppNav } from "./app-nav-provider";

export interface AppNavLinkContentProps {
  count?: number;
  label?: string;
  icon: MaterialSymbol;
  iconClassName?: string;
  isLoading?: boolean;
  hasChildren?: boolean;
}

export const AppNavLinkContent: FC<AppNavLinkContentProps> = ({
  count = 0,
  icon,
  iconClassName,
  label,
  isLoading,
  hasChildren,
}) => {
  const { isCollapsed } = useAppNav();

  return (
    <div
      className={cn("relative flex h-10 items-center text-left", isCollapsed ? "justify-center" : "justify-start pr-2")}
    >
      <span className="flex-none inline-flex items-center justify-center size-10">
        {isLoading ? <Spinner /> : <Icon icon={icon} className={cn("text-lg", iconClassName)} />}
      </span>

      {label && (
        <span className={cn("flex-auto font-medium mr-1 text-[13px] truncate", isCollapsed && "hidden")}>{label}</span>
      )}

      {count > 0 && (
        <span
          className={cn(
            "flex bg-primary h-3.5 items-center justify-center min-w-3.5 pointer-events-none px-0.75 rounded-sm text-primary-foreground text-3xs",
            "relative flex-none",
            isCollapsed && "absolute top-1 right-1"
          )}
        >
          {count}
        </span>
      )}

      {!isCollapsed && hasChildren && <Icon icon="keyboard_arrow_right" className="ml-1.5 -mr-0.5" />}
    </div>
  );
};
